/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../constants/ServiceConstants';
import utils from '../../../../common/utils';

export default class GetGraphForHistoryService extends BaseService {
  constructor() {
    super(constants.GET_GRAPH_FOR_HISTORY, 'graphHistoryCompareStatus');
  }

  getErrorMessage(data, fallback) {
    return data?.error || data?.message || fallback;
  }

  async handleEvent(eventName, event) {
    const { payload, headers } = utils.buildRequestPartsFromPayload(event);
    const { graphId, version } = payload;
    const isTemplateGraph = event.payload?.template === true;

    const requestConfig = { headers };
    if (version !== undefined && version !== null && String(version) !== '') {
      requestConfig.params = { version };
    }
    if (isTemplateGraph) {
      requestConfig.params = { ...(requestConfig.params || {}), template: true };
    }

    const { isStackB } = utils.getStackBParams();

    if (isStackB) {
      const enhancedHeaders = await utils.resolveStackBHeaders(headers);
      return this.getClient('aiadminstackb').get(`/graphs/${graphId}`, {
        ...requestConfig,
        headers: enhancedHeaders
      });
    }
    return this.getClient('aiadmin').get(`/graphs/${graphId}`, requestConfig);
  }

  handleResponse(response) {
    const { data } = response;
    const graphHistoryCompareModel = Framework.getStoreRegistry().getStore('graphHistoryCompareModel');

    if (data && data.success) {
      graphHistoryCompareModel.setGraphData(data);
    } else {
      const msg = this.getErrorMessage(data, 'Failed to load graph for history comparison');
      graphHistoryCompareModel.setError(msg);
    }
  }

  handleError(error) {
    const graphHistoryCompareModel = Framework.getStoreRegistry().getStore('graphHistoryCompareModel');
    const { response } = error;

    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      const msg = this.getErrorMessage(data, 'Failed to load graph for history comparison');
      graphHistoryCompareModel.setError(msg);
    } else if (error.message === 'timeout of 60000ms exceeded') {
      graphHistoryCompareModel.setError('Request timeout. Please try again.');
    } else {
      const msg = error.message || 'Failed to load graph for history comparison';
      graphHistoryCompareModel.setError(msg);
    }
  }
}
